var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
import { AlignMent, ChartType, FilterOp } from '@@/Tab';
import { APPEvent } from "@/events/AppEvents";
import { Chart } from "chart.js";
import { ObjectUpdateType } from "@/share/models";
import { Apphandler } from "@/ipc/MainAppHandler";
import { NoteStatus } from "@@/Annotation";
import { CommentState } from "../UIComponents/Comments";
import { LetrwingCrypto } from "@@/LetrwingCommonCrypto";
export class ChartRenderSetup {
    constructor() {
        this.canvas = null;
    }
}
export class TabStore {
    constructor() {
        this.tabsbyid = new Map();
        this.activeletrid = "";
        this.activetab = "";
        this.rendering = true;
        this.activdatasheet = null;
        this.selectedcardid = -1;
        this.buildingdetaillayout = false;
        this.buildingkanban = true;
        this.statuses = [];
        this.originalstatus = [];
        this.kandragging = false;
        this.kandraggingitem = "";
        this.kandragoverstatus = "";
        this.timelineelemnts = [];
        this.groupbycols = new Set();
        this.loadingnotes = false;
        this.showleftdetailpanel = false;
        this.notestimeout = -1;
        this.updatetimeout = -1;
        this.activerequestid = "";
        this.lastcommenttime = -1;
        this.editnoteid = "";
        this.activeobjectid = "";
        this.loadingcomments = false;
        this.lastnotesupdatetime = -1;
        this.notes = new Map();
        this.commentstate = new CommentState();
        this.statusColumns = new Map();
        this.chartrendermap = new Map();
        makeObservable(this);
        APPEvent.addSubscriberForActiveLetrObject((lt) => {
            if (lt.id !== this.activeletrid) {
                this.reset();
            }
            this.activeletrid = lt.id;
        });
        APPEvent.addSubscriberForTabsReq((req) => {
            if (req.letrid === this.activeletrid && !req.getall) {
                // lets compare two things
                const eids = Array.from(this.tabsbyid.keys());
                const ids = req.tabs.map(tab => {
                    var _a;
                    if (!this.tabsbyid.has(tab.id)) {
                        this.addtab(tab);
                    }
                    else {
                        if (((_a = this.tabsbyid.get(tab.id)) === null || _a === void 0 ? void 0 : _a.name) !== tab.name) {
                            // this.addtab(tab); we should hink if we need to do this!!
                        }
                    }
                    return tab.id;
                });
                for (const id of eids) {
                    if (ids.indexOf(id) === -1) {
                        this.deleteTab(id);
                    }
                }
            }
        });
        APPEvent.addSubscriberForGetNote((notes) => {
            if (this.loadingnotes && notes.letrid === this.activeletrid && notes.objectid === "tab-" + this.activetab) {
                this.notes = new Map();
                notes.note.forEach((n) => {
                    this.notes.set(n.id, n);
                    if (n.updatetime > this.lastnotesupdatetime) {
                        this.lastnotesupdatetime = n.updatetime;
                    }
                });
                this.setLoadingNotes(false);
                if (this.notestimeout) {
                    clearTimeout(this.notestimeout);
                }
                this.notestimeout = setTimeout(() => this.getNotesUpdate(), 5000);
            }
        });
        APPEvent.addSubscriberForNoteUpdate((up) => {
            if (up.letrid === this.activeletrid && up.objectid === "tab-" + this.activetab) {
                /// we good to go here now!!
                let lastupdatetime = -1;
                for (const n of up.notes) {
                    if (!this.notes.has(n.id)) {
                        this.notes.set(n.id, n);
                        continue;
                    }
                    if (n.updatetime > lastupdatetime) {
                        lastupdatetime = n.updatetime;
                    }
                }
                if (lastupdatetime > -1) {
                    this.lastnotesupdatetime = lastupdatetime;
                }
                else {
                    this.lastnotesupdatetime = new Date().getTime();
                }
            }
        });
        APPEvent.addSubscriberForSaveNote((sn) => {
            if (sn.letrid === this.activeletrid && sn.objectid === "tab-" + this.activetab
                && sn.reqid === this.activerequestid) {
            }
        });
        APPEvent.addSubscriberForNoteDelete((req) => {
            if (req.type === ObjectUpdateType.Comment) {
                if (req.objectid === this.editnoteid) {
                    if (req.ok) {
                        this.commentstate.removeComment(req.id);
                    }
                    else {
                        APPEvent.publishApperror("Sorry, failed to delete the comment.");
                        this.commentstate.removeCommentFromDelete(req.id);
                    }
                }
                return;
            }
        });
        APPEvent.addSubscriberForGetComments((res) => {
            if (res.noteid === this.editnoteid) {
                // lets just add these now
                res.comments.forEach(com => {
                    if (com.status && com.status === NoteStatus.Dead) {
                        this.commentstate.removeComment(com.id);
                    }
                    else {
                        this.commentstate.setComment(com);
                    }
                    if (com.updatetime > this.lastcommenttime) {
                        this.lastcommenttime = com.updatetime;
                    }
                });
                this.setLoadingComments(false);
            }
        });
        APPEvent.addSubscriberForSaveComments((res) => {
            if (this.commentstate.sendingcomments.has(res.replaceid)) {
                this.commentstate.removeSendingComment(res.replaceid);
                if (res.comment !== undefined) {
                    this.commentstate.setComment(res.comment);
                }
                else {
                    APPEvent.publishApperror("Sorry, failed to add comment");
                }
            }
        });
    }
    getCommentUpdate() {
        if (this.loadingnotes || !this.activeletrid || !this.activetab || !this.editnoteid) {
            return;
        }
        const comms = this.commentstate.getComments();
        if (this.lastcommenttime == -1) {
            this.lastcommenttime = new Date().getTime();
        }
        const updatereques = {
            letrid: this.activeletrid,
            objectid: "tab-" + this.activetab,
            since: this.lastcommenttime,
            noteid: this.editnoteid,
            referencid: '',
            updatetype: ObjectUpdateType.Comment
        };
        Apphandler.sendMessage("activeobjectid", updatereques);
    }
    getNotesUpdate() {
        this.getCommentUpdate();
        if (this.loadingnotes || !this.activeletrid || !this.activetab) {
            return;
        }
        if (this.lastnotesupdatetime === -1) {
            this.lastnotesupdatetime = new Date().getTime();
        }
        const updatereques = {
            letrid: this.activeletrid,
            objectid: "tab-" + this.activetab,
            since: this.lastnotesupdatetime,
            referencid: '',
            updatetype: ObjectUpdateType.Note
        };
        Apphandler.sendMessage("activeobjectid", updatereques);
        this.notestimeout = setTimeout(() => this.getNotesUpdate(), 10000);
    }
    setShowLeftpanel(show) {
        this.showleftdetailpanel = show;
    }
    setDragoverStatus(st) {
        this.kandragoverstatus = st;
    }
    setLoadingComments(loading) {
        this.loadingcomments = loading;
    }
    setDragging(drag) {
        this.kandragging = drag;
    }
    setDraggingId(id) {
        this.kandraggingitem = id;
    }
    setBuildingKanban(building) {
        this.buildingkanban = building;
    }
    setKbStatus(sts) {
        this.statuses.splice(0, this.statuses.length);
        this.statuses.push(...sts);
    }
    getSheet(name) {
        var _a;
        for (const sh of (_a = this.activdatasheet) === null || _a === void 0 ? void 0 : _a.sheets) {
            if (sh.name === name) {
                return sh;
            }
        }
        return null;
    }
    setBuildingDetailLayout(building) {
        this.buildingdetaillayout = building;
    }
    setActiveCardId(cadid) {
        this.selectedcardid = cadid;
    }
    buildDetailLayout(rowindex, data) {
        var _a, _b, _c, _d, _e;
        // now we have rowindex of clicked card lets just build the detail view for this!
        let myid = this.selectedcardid;
        let sheet = (_a = this.activdatasheet) === null || _a === void 0 ? void 0 : _a.sheets[0];
        this.detailLayout = undefined;
        if (data.sheetname) {
            sheet = this.getSheet(data.sheetname);
            if (!sheet) {
                this.setBuildingKanban(false);
                APPEvent.publishApperror("Sorry, panel sheet is not valid anymore " + data.sheetname);
                return;
            }
        }
        let cardscolums = [];
        let totalrows = 0;
        (_b = data.detail) === null || _b === void 0 ? void 0 : _b.rows.forEach((rw) => {
            // lets build columns for this row
            let ccls = [];
            rw.cols.forEach((col) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                ccls.push({
                    columnname: (_b = (_a = col.config) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : '',
                    sheetname: (_d = (_c = col.config) === null || _c === void 0 ? void 0 : _c.sheetname) !== null && _d !== void 0 ? _d : '',
                    ignorefirstrow: (_f = (_e = col.config) === null || _e === void 0 ? void 0 : _e.ignorefirstrow) !== null && _f !== void 0 ? _f : false,
                    itemlabel: (_h = (_g = col.config) === null || _g === void 0 ? void 0 : _g.y) !== null && _h !== void 0 ? _h : ''
                });
            });
            cardscolums.push(ccls);
        });
        const rw = [];
        for (const crow of cardscolums) {
            const drw = [];
            for (const ccol of crow) {
                try {
                    if (!ccol.columnname) {
                        continue;
                    }
                    let ccname = "";
                    for (let i = 0; i < ccol.columnname.length; i++) {
                        if (ccol.columnname[i].match(/[a-z]/i)) {
                            ccname += ccol.columnname[i].toUpperCase();
                        }
                    }
                    // lets now get the data and we done here!
                    const rindex = (_c = this.getRangeIndexes) === null || _c === void 0 ? void 0 : _c.call(this, sheet.name + "!" + ccname + "" + rowindex);
                    if (!rindex) {
                        continue;
                    }
                    const cell = (_d = this.getcell) === null || _d === void 0 ? void 0 : _d.call(this, rindex[0], rindex[1], sheet);
                    const value = this.activdatasheet.getDisplayText(cell);
                    drw.push({
                        key: (_e = ccol.itemlabel) !== null && _e !== void 0 ? _e : '',
                        value: value,
                        alignment: AlignMent.Left,
                        rowindex: rindex[0],
                        colindex: rindex[1],
                        address: sheet.name + "!" + ccname + "" + rowindex
                    });
                }
                catch (ex) { }
            }
            rw.push(drw);
        }
        if (this.selectedcardid === myid) {
            this.detailLayout = {
                rowindex: rowindex,
                uidata: rw,
                sheetname: sheet.name,
                color: "rgba(" + Math.floor(Math.random() * 255) + "," + Math.floor(Math.random() * 255) + ","
                    +
                        Math.floor(Math.random() * 255) + ", 0.3)"
            };
            this.setBuildingDetailLayout(false);
        }
    }
    getCardsForParentAndStatus(status, parent) {
        var _a, _b;
        return (_b = (_a = this.statusColumns.get(status)) === null || _a === void 0 ? void 0 : _a.filter((val) => val.parentid === parent)) !== null && _b !== void 0 ? _b : [];
    }
    setLoadingNotes(loading) {
        this.loadingnotes = loading;
    }
    buildCardDisplay(data, filter) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.detailLayout = undefined;
        this.setBuildingDetailLayout(false);
        this.setActiveCardId(-1);
        this.timelineelemnts.splice(0, this.timelineelemnts.length);
        let sheet = (_a = this.activdatasheet) === null || _a === void 0 ? void 0 : _a.sheets[0];
        if (data.sheetname) {
            sheet = this.getSheet(data.sheetname);
            if (!sheet) {
                this.setBuildingKanban(false);
                APPEvent.publishApperror("Sorry, panel sheet is not valid anymore " + data.sheetname);
                return;
            }
        }
        const displaystatus = [];
        const displaystatusset = new Set();
        let cardscolums = [];
        let totalrows = 0;
        (_b = data.layout) === null || _b === void 0 ? void 0 : _b.rows.forEach((rw) => {
            // lets build columns for this row
            let ccls = [];
            rw.cols.forEach((col) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                if ((_a = col.config) === null || _a === void 0 ? void 0 : _a.x) {
                    ccls.push({
                        columnname: (_c = (_b = col.config) === null || _b === void 0 ? void 0 : _b.x) !== null && _c !== void 0 ? _c : '',
                        sheetname: (_e = (_d = col.config) === null || _d === void 0 ? void 0 : _d.sheetname) !== null && _e !== void 0 ? _e : '',
                        ignorefirstrow: (_g = (_f = col.config) === null || _f === void 0 ? void 0 : _f.ignorefirstrow) !== null && _g !== void 0 ? _g : false,
                        itemlabel: (_j = (_h = col.config) === null || _h === void 0 ? void 0 : _h.y) !== null && _j !== void 0 ? _j : ''
                    });
                }
            });
            if (ccls.length > 0) {
                cardscolums.push(ccls);
            }
        });
        for (let i = 0; i <= sheet.rows.length; i++) {
            // now we have the row lets construct the card now!
            try {
                let userow = true;
                for (const fil of filter !== null && filter !== void 0 ? filter : []) {
                    const col = fil.key.toUpperCase();
                    const rindex = (_c = this.getRangeIndexes) === null || _c === void 0 ? void 0 : _c.call(this, sheet.name + "!" + col + "" + i);
                    if (!rindex) {
                        continue;
                    }
                    const cell = (_d = this.getcell) === null || _d === void 0 ? void 0 : _d.call(this, rindex[0], rindex[1], sheet);
                    if (!cell) {
                        continue;
                    }
                    // now 
                    const displaytext = (_e = this.activdatasheet.getDisplayText(cell)) !== null && _e !== void 0 ? _e : '';
                    if (!this.checkValueMatchFilter(displaytext, [fil])) {
                        userow = false;
                        break;
                    }
                }
                if (!userow) {
                    continue;
                }
                const rw = [];
                for (const crow of cardscolums) {
                    const drw = [];
                    for (const ccol of crow) {
                        if ((i === 0 || i === 1) && ccol.ignorefirstrow) {
                            continue;
                        }
                        if (!ccol.columnname) {
                            continue;
                        }
                        let ccname = "";
                        for (let i = 0; i < ccol.columnname.length; i++) {
                            if (ccol.columnname[i].match(/[a-z]/i)) {
                                ccname += ccol.columnname[i].toUpperCase();
                            }
                        }
                        // lets now get the data and we done here!
                        const rindex = (_f = this.getRangeIndexes) === null || _f === void 0 ? void 0 : _f.call(this, sheet.name + "!" + ccname + "" + i);
                        if (!rindex) {
                            continue;
                        }
                        const cell = (_g = this.getcell) === null || _g === void 0 ? void 0 : _g.call(this, rindex[0], rindex[1], sheet);
                        const value = this.activdatasheet.getDisplayText(cell);
                        drw.push({
                            key: (_h = ccol.itemlabel) !== null && _h !== void 0 ? _h : '',
                            value: value,
                            alignment: AlignMent.Left,
                            rowindex: rindex[0],
                            colindex: rindex[1],
                            address: sheet.name + "!" + ccname + "" + i
                        });
                    }
                    if (drw.length > 0) {
                        rw.push(drw);
                    }
                }
                if (rw.length > 0) {
                    this.timelineelemnts.push({
                        status: "",
                        layout: {
                            uidata: rw,
                            rowindex: i,
                            sheetname: sheet.name,
                            color: "rgba(" + Math.floor(Math.random() * 255) + "," + Math.floor(Math.random() * 255) + ","
                                +
                                    Math.floor(Math.random() * 255) + ", 0.3)"
                        }
                    });
                }
            }
            catch (ex) {
                console.log(ex);
            }
        }
        this.setKbStatus(displaystatus);
        this.setBuildingKanban(false);
    }
    loadComments() {
        if (this.loadingcomments || !this.editnoteid) {
            return;
        }
        this.setLoadingComments(true);
        this.commentstate.clear();
        const getcoom = {
            letrid: this.activeletrid,
            objectid: "tab-" + this.activetab,
            noteid: this.editnoteid
        };
        Apphandler.sendMessage("getcomments", getcoom);
    }
    buildTimeline(data, filter) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        this.timelineelemnts.splice(0, this.timelineelemnts.length);
        if (!data.statuscolumn) {
            this.setBuildingKanban(false);
            APPEvent.publishApperror("Sorry, timeline missing section column");
            return;
        }
        let statusalpha = "";
        let ignorecheck = true;
        for (let i = 0; i < data.statuscolumn.length; i++) {
            if (data.statuscolumn[i].match(/[a-z]/i)) {
                statusalpha += data.statuscolumn[i].toUpperCase();
            }
        }
        let sheet = (_a = this.activdatasheet) === null || _a === void 0 ? void 0 : _a.sheets[0];
        if (data.sheetname) {
            sheet = this.getSheet(data.sheetname);
            if (!sheet) {
                this.setBuildingKanban(false);
                APPEvent.publishApperror("Sorry, timeline sheet is not valid anymore " + data.sheetname);
                return;
            }
        }
        const scolindex = (_b = this.getColIndex) === null || _b === void 0 ? void 0 : _b.call(this, statusalpha);
        const colum = (_c = this.getcolumn) === null || _c === void 0 ? void 0 : _c.call(this, sheet, scolindex !== null && scolindex !== void 0 ? scolindex : -1);
        if (colum && colum.format && colum.format.format) {
            const format = (_d = this.getTypeFromFormat) === null || _d === void 0 ? void 0 : _d.call(this, colum.format.format);
            if (format === "ShortDate" || format === "LongDate" || format === "Time") {
                ignorecheck = true;
            }
        }
        const displaystatus = [];
        const displaystatusset = new Set();
        let cardscolums = [];
        let totalrows = 0;
        (_e = data.layout) === null || _e === void 0 ? void 0 : _e.rows.forEach((rw) => {
            // lets build columns for this row
            let ccls = [];
            rw.cols.forEach((col) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                ccls.push({
                    columnname: (_b = (_a = col.config) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : '',
                    sheetname: (_d = (_c = col.config) === null || _c === void 0 ? void 0 : _c.sheetname) !== null && _d !== void 0 ? _d : '',
                    ignorefirstrow: (_f = (_e = col.config) === null || _e === void 0 ? void 0 : _e.ignorefirstrow) !== null && _f !== void 0 ? _f : false,
                    itemlabel: (_h = (_g = col.config) === null || _g === void 0 ? void 0 : _g.y) !== null && _h !== void 0 ? _h : ''
                });
            });
            cardscolums.push(ccls);
        });
        for (let i = 0; i <= sheet.rows.length; i++) {
            // now we have the row lets construct the card now!
            try {
                let userow = true;
                for (const fil of filter !== null && filter !== void 0 ? filter : []) {
                    const col = fil.key.toUpperCase();
                    const rindex = (_f = this.getRangeIndexes) === null || _f === void 0 ? void 0 : _f.call(this, sheet.name + "!" + col + "" + i);
                    if (!rindex) {
                        continue;
                    }
                    const cell = (_g = this.getcell) === null || _g === void 0 ? void 0 : _g.call(this, rindex[0], rindex[1], sheet);
                    if (!cell) {
                        continue;
                    }
                    // now 
                    const displaytext = (_h = this.activdatasheet.getDisplayText(cell)) !== null && _h !== void 0 ? _h : '';
                    if (!this.checkValueMatchFilter(displaytext, [fil])) {
                        userow = false;
                        break;
                    }
                }
                if (!userow) {
                    continue;
                }
                const rindex = (_j = this.getRangeIndexes) === null || _j === void 0 ? void 0 : _j.call(this, sheet.name + "!" + statusalpha + "" + i);
                if (!rindex) {
                    continue;
                }
                const cell = (_k = this.getcell) === null || _k === void 0 ? void 0 : _k.call(this, rindex[0], rindex[1], sheet);
                if (!(cell === null || cell === void 0 ? void 0 : cell.value)) {
                    continue;
                }
                const st = this.activdatasheet.getDisplayText(cell);
                // lets add now a card here!
                if (!ignorecheck) {
                    if (!cell.format) {
                        continue;
                    }
                    const format = (_l = this.getTypeFromFormat) === null || _l === void 0 ? void 0 : _l.call(this, cell.format);
                    if (format === "ShortDate" || format === "LongDate" || format === "Time") {
                    }
                    else {
                        continue;
                    }
                }
                const rw = [];
                for (const crow of cardscolums) {
                    const drw = [];
                    for (const ccol of crow) {
                        if ((i === 0 || i === 1) && ccol.ignorefirstrow) {
                            continue;
                        }
                        if (!ccol.columnname) {
                            continue;
                        }
                        let ccname = "";
                        for (let i = 0; i < ccol.columnname.length; i++) {
                            if (ccol.columnname[i].match(/[a-z]/i)) {
                                ccname += ccol.columnname[i].toUpperCase();
                            }
                        }
                        // lets now get the data and we done here!
                        const rindex = (_m = this.getRangeIndexes) === null || _m === void 0 ? void 0 : _m.call(this, sheet.name + "!" + ccname + "" + i);
                        if (!rindex) {
                            continue;
                        }
                        const cell = (_o = this.getcell) === null || _o === void 0 ? void 0 : _o.call(this, rindex[0], rindex[1], sheet);
                        const value = this.activdatasheet.getDisplayText(cell);
                        drw.push({
                            key: (_p = ccol.itemlabel) !== null && _p !== void 0 ? _p : '',
                            value: value,
                            alignment: AlignMent.Left,
                            rowindex: rindex[0],
                            colindex: rindex[1],
                            address: sheet.name + "!" + ccname + "" + i
                        });
                    }
                    rw.push(drw);
                }
                this.timelineelemnts.push({
                    status: st,
                    layout: {
                        uidata: rw,
                        sheetname: sheet.name,
                        rowindex: i,
                        color: "rgba(" + Math.floor(Math.random() * 255) + "," + Math.floor(Math.random() * 255) + ","
                            +
                                Math.floor(Math.random() * 255) + ", 0.3)"
                    }
                });
            }
            catch (ex) {
                console.log(ex);
            }
        }
        this.setKbStatus(displaystatus);
        this.setBuildingKanban(false);
    }
    checkValueMatchFilter(val, filter) {
        val = val.trim();
        for (const fil of filter) {
            if (fil.op === FilterOp.Eq) {
                if (val !== fil.value) {
                    return false;
                }
            }
            else if (fil.op === FilterOp.NEq) {
                if (val === fil.value) {
                    return false;
                }
            }
            else if (fil.op === FilterOp.GT) {
                if (val <= fil.value) {
                    return false;
                }
            }
            else if (fil.op === FilterOp.LT) {
                if (val >= fil.value) {
                    return false;
                }
            }
            else if (fil.op === FilterOp.GTE) {
                if (val < fil.value) {
                    return false;
                }
            }
            else if (fil.op === FilterOp.LTE) {
                if (val > fil.value) {
                    return false;
                }
            }
            else if (fil.op === FilterOp.In) {
                if (fil.value.split(",").indexOf(val) === -1) {
                    return false;
                }
            }
            else if (fil.op === FilterOp.NotIn) {
                if (fil.value.split(",").indexOf(val) !== -1) {
                    return false;
                }
            }
        }
        return true;
    }
    buildKanban(data, filter) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
        let filtercolumnds = new Map();
        if (filter) {
            for (const fil of filter) {
                const cindex = (_a = this.getColIndex) === null || _a === void 0 ? void 0 : _a.call(this, fil.key);
                if (!cindex) {
                    continue;
                }
                if (!filtercolumnds.has(cindex)) {
                    filtercolumnds.set(cindex, []);
                }
                (_b = filtercolumnds.get(cindex)) === null || _b === void 0 ? void 0 : _b.push(fil);
            }
        }
        this.statusColumns.clear();
        this.groupbycols.clear();
        if (!data.statuscolumn) {
            this.setBuildingKanban(false);
            APPEvent.publishApperror("Sorry, kanban missing status column");
            return;
        }
        let statusalpha = "";
        for (let i = 0; i < data.statuscolumn.length; i++) {
            if (data.statuscolumn[i].match(/[a-z]/i)) {
                statusalpha += data.statuscolumn[i].toUpperCase();
            }
        }
        let sheet = (_c = this.activdatasheet) === null || _c === void 0 ? void 0 : _c.sheets[0];
        if (data.sheetname) {
            sheet = this.getSheet(data.sheetname);
            if (!sheet) {
                this.setBuildingKanban(false);
                APPEvent.publishApperror("Sorry, kanban sheet is not valid anymore " + data.sheetname);
                return;
            }
        }
        const status = [];
        const displaystatus = [];
        const displaystatusset = new Set();
        const scolindex = (_d = this.getColIndex) === null || _d === void 0 ? void 0 : _d.call(this, statusalpha);
        const col = (_e = this.getcolumn) === null || _e === void 0 ? void 0 : _e.call(this, sheet, scolindex !== null && scolindex !== void 0 ? scolindex : -1);
        if (!col) {
            APPEvent.publishApperror("Sorry, kanban status column is not valid anymore " + sheet.name + "!" + statusalpha);
            this.setBuildingKanban(false);
            return;
        }
        const valmodel = col.validation;
        let vals = [];
        if (valmodel && valmodel.value1) {
            vals = valmodel.value1.split(",");
        }
        else if (valmodel && valmodel.value2) {
            vals = valmodel.value2.split(",");
        }
        else {
            const donestatus = new Set();
            for (let i = 0; i <= sheet.rows.length; i++) {
                const rindex = (_f = this.getRangeIndexes) === null || _f === void 0 ? void 0 : _f.call(this, sheet.name + "!" + col + "" + i);
                if (!rindex) {
                    continue;
                }
                const cell = (_g = this.getcell) === null || _g === void 0 ? void 0 : _g.call(this, rindex[0], rindex[1], sheet);
                if (!cell) {
                    continue;
                }
                const value = (_h = this.activdatasheet.getDisplayText(cell)) !== null && _h !== void 0 ? _h : '';
                if (!value || donestatus.has(value.toLowerCase())) {
                    continue;
                }
                vals.push(value);
            }
        }
        if (!vals || vals.length === 0) {
            APPEvent.publishApperror("Sorry, but found no statuses for Kanban board for configured column and sheet " + sheet.name + "!" + statusalpha);
            this.setBuildingKanban(false);
            return;
        }
        let cfilter = [];
        if (scolindex && filtercolumnds.has(scolindex)) {
            cfilter = (_j = filtercolumnds.get(scolindex)) !== null && _j !== void 0 ? _j : [];
        }
        for (let val of vals) {
            if (cfilter && cfilter.length > 0) {
                if (!this.checkValueMatchFilter(val, cfilter)) {
                    continue;
                }
            }
            if (!displaystatusset.has(val.toLowerCase().trim())) {
                displaystatus.push(val.trim());
                status.push(val.toLowerCase().trim());
                displaystatusset.add(val.toLowerCase().trim());
            }
        }
        if (displaystatus.length === 0) {
            APPEvent.publishApperror("Sorry, but found no statuses for Kanban board for configured column and sheet " + sheet.name + "!" + statusalpha);
            return;
        }
        let groupcol = "";
        if (data.groupby) {
            for (let i = 0; i < data.groupby.length; i++) {
                if (data.groupby[i].match(/[a-z]/i)) {
                    groupcol += data.groupby[i].toUpperCase();
                }
            }
            const scolindex = (_k = this.getColIndex) === null || _k === void 0 ? void 0 : _k.call(this, groupcol);
            const col = (_l = this.getcolumn) === null || _l === void 0 ? void 0 : _l.call(this, sheet, (_o = (_m = this.getColIndex) === null || _m === void 0 ? void 0 : _m.call(this, groupcol)) !== null && _o !== void 0 ? _o : -1);
            if (col) {
                const valmodel = col.validation;
                let vals = [];
                if (valmodel && (valmodel.value1 || valmodel.value2)) {
                    if (valmodel.value1) {
                        vals = valmodel.value1.split(",");
                    }
                    else if (valmodel.value2) {
                        vals = valmodel.value2.split(",");
                    }
                    let cfilter = [];
                    if (scolindex && filtercolumnds.has(scolindex)) {
                        cfilter = (_p = filtercolumnds.get(scolindex)) !== null && _p !== void 0 ? _p : [];
                    }
                }
                else {
                    const donestatus = new Set();
                    for (let i = 0; i <= sheet.rows.length; i++) {
                        const rindex = (_q = this.getRangeIndexes) === null || _q === void 0 ? void 0 : _q.call(this, sheet.name + "!" + col + "" + i);
                        if (!rindex) {
                            continue;
                        }
                        const cell = (_r = this.getcell) === null || _r === void 0 ? void 0 : _r.call(this, rindex[0], rindex[1], sheet);
                        if (!cell) {
                            continue;
                        }
                        const value = (_s = this.activdatasheet.getDisplayText(cell)) !== null && _s !== void 0 ? _s : '';
                        if (!value || donestatus.has(value.toLowerCase())) {
                            continue;
                        }
                        vals.push(value);
                    }
                }
                if (vals.length > 0) {
                    vals.forEach((val) => {
                        if (cfilter && cfilter.length > 0 && !this.checkValueMatchFilter(val, cfilter)) {
                        }
                        else {
                            this.groupbycols.add(val.trim());
                        }
                    });
                }
            }
        }
        this.setKbStatus(displaystatus);
        // lets build the crads now!!
        let cardscolums = [];
        let totalrows = 0;
        (_t = data.layout) === null || _t === void 0 ? void 0 : _t.rows.forEach((rw) => {
            // lets build columns for this row
            let ccls = [];
            rw.cols.forEach((col) => {
                var _a, _b, _c, _d, _e, _f, _g, _h;
                ccls.push({
                    columnname: (_b = (_a = col.config) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : '',
                    sheetname: (_d = (_c = col.config) === null || _c === void 0 ? void 0 : _c.sheetname) !== null && _d !== void 0 ? _d : '',
                    ignorefirstrow: (_f = (_e = col.config) === null || _e === void 0 ? void 0 : _e.ignorefirstrow) !== null && _f !== void 0 ? _f : false,
                    itemlabel: (_h = (_g = col.config) === null || _g === void 0 ? void 0 : _g.y) !== null && _h !== void 0 ? _h : ''
                });
            });
            cardscolums.push(ccls);
        });
        for (let i = 0; i <= sheet.rows.length; i++) {
            try {
                // we only do this row if matches the filter !
                let userow = true;
                for (const fil of filter !== null && filter !== void 0 ? filter : []) {
                    const col = fil.key.toUpperCase();
                    const rindex = (_u = this.getRangeIndexes) === null || _u === void 0 ? void 0 : _u.call(this, sheet.name + "!" + col + "" + i);
                    if (!rindex) {
                        continue;
                    }
                    const cell = (_v = this.getcell) === null || _v === void 0 ? void 0 : _v.call(this, rindex[0], rindex[1], sheet);
                    if (!cell) {
                        continue;
                    }
                    // now 
                    const displaytext = (_w = this.activdatasheet.getDisplayText(cell)) !== null && _w !== void 0 ? _w : '';
                    if (!this.checkValueMatchFilter(displaytext, [fil])) {
                        userow = false;
                        break;
                    }
                }
                if (!userow) {
                    continue;
                }
                const rindex = (_x = this.getRangeIndexes) === null || _x === void 0 ? void 0 : _x.call(this, sheet.name + "!" + statusalpha + "" + i);
                if (!rindex) {
                    continue;
                }
                const cell = (_y = this.getcell) === null || _y === void 0 ? void 0 : _y.call(this, rindex[0], rindex[1], sheet);
                if (!(cell === null || cell === void 0 ? void 0 : cell.value)) {
                    continue;
                }
                let parentid = "";
                if (groupcol) {
                    const rindex = (_z = this.getRangeIndexes) === null || _z === void 0 ? void 0 : _z.call(this, sheet.name + "!" + groupcol + "" + i);
                    if (rindex) {
                        const cell = (_0 = this.getcell) === null || _0 === void 0 ? void 0 : _0.call(this, rindex[0], rindex[1], sheet);
                        if (cell) {
                            parentid = (_1 = this.activdatasheet.getDisplayText(cell)) !== null && _1 !== void 0 ? _1 : '';
                        }
                    }
                }
                const inde = status.indexOf(cell.value.toLowerCase().trim());
                if (inde !== -1) {
                    // lets build key value pair for this row now!
                    const rw = [];
                    for (const crow of cardscolums) {
                        const drw = [];
                        for (const ccol of crow) {
                            try {
                                if ((i === 0 || i === 1) && ccol.ignorefirstrow) {
                                    continue;
                                }
                                let ccname = "";
                                for (let i = 0; i < ccol.columnname.length; i++) {
                                    if (ccol.columnname[i].match(/[a-z]/i)) {
                                        ccname += ccol.columnname[i].toUpperCase();
                                    }
                                }
                                // lets now get the data and we done here!
                                const rindex = (_2 = this.getRangeIndexes) === null || _2 === void 0 ? void 0 : _2.call(this, sheet.name + "!" + ccname + "" + i);
                                if (!rindex) {
                                    continue;
                                }
                                const cell = (_3 = this.getcell) === null || _3 === void 0 ? void 0 : _3.call(this, rindex[0], rindex[1], sheet);
                                const value = this.activdatasheet.getDisplayText(cell);
                                drw.push({
                                    key: (_4 = ccol.itemlabel) !== null && _4 !== void 0 ? _4 : '',
                                    value: value,
                                    alignment: AlignMent.Left,
                                    rowindex: rindex[0],
                                    colindex: rindex[1],
                                    address: sheet.name + "!" + ccname + "" + i
                                });
                            }
                            catch (ex) { }
                        }
                        rw.push(drw);
                    }
                    if (!this.statusColumns.has(cell.value.toLowerCase().trim())) {
                        this.statusColumns.set(cell.value.toLowerCase().trim(), []);
                    }
                    (_5 = this.statusColumns.get(cell.value.toLowerCase().trim())) === null || _5 === void 0 ? void 0 : _5.push({
                        uidata: rw,
                        rowindex: i,
                        sheetname: sheet.name,
                        parentid: parentid.trim(),
                        color: "rgba(" + Math.floor(Math.random() * 255) + "," + Math.floor(Math.random() * 255) + ","
                            +
                                Math.floor(Math.random() * 255) + ", 0.3)"
                    });
                }
            }
            catch (ex) {
                console.log(ex);
            }
        }
        this.setBuildingKanban(false);
    }
    moveDraggCard(ostatus, tostatus) {
        var _a, _b, _c;
        if (this.dragcard) {
            const index = (_a = this.statusColumns.get(ostatus.toLowerCase())) === null || _a === void 0 ? void 0 : _a.indexOf(this.dragcard);
            if (index !== undefined && index != -1) {
                (_b = this.statusColumns.get(ostatus.toLowerCase())) === null || _b === void 0 ? void 0 : _b.splice(index, 1);
                if (!this.statusColumns.get(tostatus.toLowerCase())) {
                    this.statusColumns.set(tostatus.toLowerCase(), []);
                }
                (_c = this.statusColumns.get(tostatus.toLowerCase())) === null || _c === void 0 ? void 0 : _c.push(this.dragcard);
            }
        }
    }
    setRendering(ren) {
        this.rendering = ren;
    }
    setActiveNode(rowindex, columnindex) {
        const id = LetrwingCrypto.hash512str(this.activeobjectid + rowindex + columnindex);
        this.editnoteid = "tab-" + id;
        this.loadComments();
    }
    setActiveTabId(id) {
        this.activetab = id;
    }
    addtab(tab) {
        this.tabsbyid.set(tab.id, tab);
    }
    getNotes() {
        if (this.loadingnotes) {
            return;
        }
        this.setLoadingNotes(true);
        this.lastnotesupdatetime = -1;
        const tab = this.tabsbyid.get(this.activetab);
        if (tab !== undefined) {
            const req = {
                letrid: this.activeletrid,
                objectid: "tab-" + this.activetab,
                referencid: tab === null || tab === void 0 ? void 0 : tab.modelid,
                ischooser: false
            };
            Apphandler.sendMessage("getnotes", req);
            if (this.notestimeout) {
                clearTimeout(this.notestimeout);
            }
        }
    }
    deleteTab(id) {
        this.tabsbyid.delete(id);
    }
    saveComment(com) {
        var _a;
        if (this.editnoteid) {
            const savereq = {
                letrid: this.activeletrid,
                objectid: "tab-" + this.activetab,
                replaceid: com.id,
                text: (_a = com.datastr) !== null && _a !== void 0 ? _a : "",
                noteid: this.editnoteid
            };
            Apphandler.sendMessage("addcomment", savereq);
        }
    }
    deleteComment(id) {
        const req = {
            letrid: this.activeletrid,
            objectid: this.editnoteid,
            id: id
        };
        Apphandler.sendMessage("deletecomment", req);
    }
    reset(fullreset = true) {
        if (this.notestimeout > -1) {
            clearTimeout(this.notestimeout);
        }
        if (this.updatetimeout > -1) {
            clearTimeout(this.updatetimeout);
        }
        this.commentstate.clear();
        this.notestimeout = -1;
        this.updatetimeout = -1;
        this.editnoteid = "";
        this.setLoadingNotes(false);
        if (fullreset) {
            this.tabsbyid.clear();
        }
        this.setActiveCardId(-1);
        this.setActiveTabId("");
        this.statuses.splice(0, this.statuses.length);
        this.statusColumns.clear();
    }
    getTabs() {
        return Array.from(this.tabsbyid.values()).slice().filter(t => t.name !== undefined)
            .sort((t1, t2) => { var _a, _b, _c, _d; return ((_b = (_a = t1.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '').localeCompare((_d = (_c = t2.name) === null || _c === void 0 ? void 0 : _c.toLowerCase()) !== null && _d !== void 0 ? _d : ''); });
    }
    getDefaultTab() {
        if (this.tabsbyid.size > 0) {
            return this.getTabs()[0].id;
        }
        return "";
    }
    addColumnSetup(id, col) {
        this.chartrendermap.set(id, col);
        // we will now setup
        setTimeout(() => this.setupChart(id), 100);
    }
    setupChart(id) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
        if (!this.activdatasheet) {
            return;
        }
        const cdata = this.chartrendermap.get(id);
        if (cdata && cdata.canvas && this.getRangeIndexes) {
            let sheet = (_a = this.activdatasheet) === null || _a === void 0 ? void 0 : _a.sheets[0];
            if (cdata.col && ((_b = cdata.col.config) === null || _b === void 0 ? void 0 : _b.sheetname)) {
                let found = false;
                for (const sh of (_c = this.activdatasheet) === null || _c === void 0 ? void 0 : _c.sheets) {
                    if (sh.name === ((_d = cdata.col.config) === null || _d === void 0 ? void 0 : _d.sheetname)) {
                        sheet = sh;
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    // we dont need to show this now!
                    return;
                }
            }
            if (cdata.col && ((_e = cdata.col) === null || _e === void 0 ? void 0 : _e.charttype) !== ChartType.Scatter) {
                const xcol = (_f = cdata.col.config) === null || _f === void 0 ? void 0 : _f.x;
                const ycol = (_g = cdata.col.config) === null || _g === void 0 ? void 0 : _g.y;
                if (xcol && ycol) {
                    if (sheet && sheet.rows && ((_h = sheet.rows) === null || _h === void 0 ? void 0 : _h.length) > 0) {
                        let Acolname = "";
                        for (let i = 0; i < xcol.length; i++) {
                            if (xcol[i].match(/[a-z]/i)) {
                                Acolname += xcol[i].toUpperCase();
                            }
                        }
                        let bcolname = "";
                        for (let i = 0; i < ycol.length; i++) {
                            if (ycol[i].match(/[a-z]/i)) {
                                bcolname += ycol[i].toUpperCase();
                            }
                        }
                        const xdata = [];
                        const colors = [];
                        // for each row lets get data in x and y directions
                        for (let i = 0; i < sheet.rows.length; i++) {
                            const rindex = (_j = this.getRangeIndexes) === null || _j === void 0 ? void 0 : _j.call(this, sheet.name + "!" + Acolname + "" + i);
                            const cell = (_k = this.getcell) === null || _k === void 0 ? void 0 : _k.call(this, rindex[0], rindex[1], sheet);
                            if (cell) {
                                xdata.push((_l = cell.value) !== null && _l !== void 0 ? _l : '');
                            }
                            colors.push("rgba(" + Math.floor(Math.random() * 255) + "," + Math.floor(Math.random() * 255) + ","
                                +
                                    Math.floor(Math.random() * 255) + ", 0.3)");
                        }
                        const ydata = [];
                        // for each row lets get data in x and y directions
                        for (let i = 0; i < sheet.rows.length; i++) {
                            const rindex = (_m = this.getRangeIndexes) === null || _m === void 0 ? void 0 : _m.call(this, sheet.name + "!" + bcolname + "" + i);
                            const cell = (_o = this.getcell) === null || _o === void 0 ? void 0 : _o.call(this, rindex[0], rindex[1], sheet);
                            if (cell) {
                                ydata.push((_p = cell.value) !== null && _p !== void 0 ? _p : '');
                            }
                        }
                        const label = (_r = (_q = cdata.col) === null || _q === void 0 ? void 0 : _q.config) === null || _r === void 0 ? void 0 : _r.ylab;
                        let bcolorl = colors[0];
                        if (((_s = cdata.col) === null || _s === void 0 ? void 0 : _s.charttype) === ChartType.Line && ((_u = (_t = cdata.col) === null || _t === void 0 ? void 0 : _t.config) === null || _u === void 0 ? void 0 : _u.xlab)) {
                            bcolorl = (_w = (_v = cdata.col) === null || _v === void 0 ? void 0 : _v.config) === null || _w === void 0 ? void 0 : _w.xlab;
                        }
                        new Chart(cdata.canvas, {
                            type: ((_x = cdata.col) === null || _x === void 0 ? void 0 : _x.charttype) === ChartType.Bar ? 'bar' :
                                ((_y = cdata.col) === null || _y === void 0 ? void 0 : _y.charttype) === ChartType.Pie ? 'pie' :
                                    ((_z = cdata.col) === null || _z === void 0 ? void 0 : _z.charttype) === ChartType.Line ? 'line' :
                                        'doughnut',
                            data: {
                                labels: xdata,
                                datasets: [{
                                        label: label,
                                        data: ydata,
                                        backgroundColor: ((_0 = cdata.col) === null || _0 === void 0 ? void 0 : _0.charttype) !== ChartType.Line ? colors : undefined,
                                        borderColor: ((_1 = cdata.col) === null || _1 === void 0 ? void 0 : _1.charttype) === ChartType.Line ? bcolorl : colors
                                    }],
                            },
                            options: {
                                scales: {}
                            }
                        });
                    }
                }
            }
            else if (((_2 = cdata.col) === null || _2 === void 0 ? void 0 : _2.charttype) === ChartType.Doughnut) {
            }
        }
    }
}
__decorate([
    observable,
    __metadata("design:type", Map)
], TabStore.prototype, "tabsbyid", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], TabStore.prototype, "activetab", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TabStore.prototype, "rendering", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TabStore.prototype, "selectedcardid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TabStore.prototype, "buildingdetaillayout", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TabStore.prototype, "buildingkanban", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], TabStore.prototype, "statuses", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TabStore.prototype, "kandragging", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TabStore.prototype, "kandraggingitem", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TabStore.prototype, "kandragoverstatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], TabStore.prototype, "timelineelemnts", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], TabStore.prototype, "groupbycols", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TabStore.prototype, "loadingnotes", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TabStore.prototype, "showleftdetailpanel", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], TabStore.prototype, "loadingcomments", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], TabStore.prototype, "statusColumns", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "setShowLeftpanel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "setDragoverStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "setLoadingComments", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "setDraggingId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "setBuildingKanban", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "setBuildingDetailLayout", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "setActiveCardId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Object]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "buildDetailLayout", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "setLoadingNotes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Array]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "buildCardDisplay", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Array]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "buildTimeline", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Array]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "buildKanban", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "moveDraggCard", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "setRendering", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "setActiveTabId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "addtab", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "deleteTab", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], TabStore.prototype, "reset", null);
